export function IconLineBeta({
  color = 'currentColor',
  height = 1,
  className,
  style,
  ...props
}: React.SVGProps<SVGSVGElement> & { color?: string; height?: number }) {
  const mid = height / 2;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height={height}
      viewBox={`0 0 100 ${height}`}
      preserveAspectRatio="none"
      className={className}
      style={{ display: 'block', width: '100%', height, ...style }}
      aria-hidden="true"
      {...props}
    >
      <line
        x1="0"
        y1={mid}
        x2="100"
        y2={mid}
        stroke={color}
        strokeWidth={height}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="square"
      />
    </svg>
  );
}